import type { ReactNode } from "react";
import "./styles.css";

export interface TenantHeaderProps {
  logoUrl: string;
  tenantName: string;
  /** KYC-design — the right-hand slot: save status and "Save and finish later". */
  aside?: ReactNode;
}

export function TenantHeader({ logoUrl, tenantName, aside }: TenantHeaderProps) {
  return (
    <header className="form-header">
      <img className="tenant-logo" src={logoUrl} alt={`${tenantName} logo`} />
      {aside && <div className="form-header-aside">{aside}</div>}
    </header>
  );
}

export function PageFooter({ note }: { note?: string }) {
  return (
    <footer className="form-footer">
      <p>{note ?? ""}</p>
      <p className="footer-attribution">Powered by AR Dept</p>
    </footer>
  );
}
